import * as React from "react";
import { useEffect, useState } from "react";
import { LookupTablesActions } from "stores/lookup-tables/LookupTablesStore";
import LookupTableParameterEdit from "components/lookup-table-parameters/LookupTableParameterEdit";
const useLoadLookupTables = () => {
  const [lookupTables, setLookupTables] = useState();
  useEffect(() => {
    LookupTablesActions.searchPaginated(1, 0, void 0, false).then(
      ({ lookup_tables }) => setLookupTables(lookup_tables)
    );
  }, []);
  return lookupTables;
};
const useValidation = ({ onValidate, tableKey, lookupTable, idx }) => {
  useEffect(() => {
    const _validationState = tableKey !== void 0 && tableKey !== "" ? ["success"] : ["error", "Lookup table key is required"];
    onValidate(idx, { key: _validationState });
    return () => onValidate(idx, { key: ["success"] });
  }, [tableKey, idx, onValidate]);
  useEffect(() => {
    const _validationState = lookupTable !== void 0 && lookupTable !== "" ? ["success"] : ["error", "Please select a lookup table"];
    onValidate(idx, { lookupTable: _validationState });
    return () => onValidate(idx, { lookupTable: ["success"] });
  }, [lookupTable, idx, onValidate]);
};
const LookupTableParameterForm = ({
  idx,
  onChange,
  validationState,
  parameter,
  onValidate
}) => {
  const { key: tableKey, lookupTable } = parameter;
  const lookupTables = useLoadLookupTables();
  useValidation({ onValidate, tableKey, lookupTable, idx });
  return /* @__PURE__ */ React.createElement(
    LookupTableParameterEdit,
    {
      onChange,
      lookupTables,
      identifier: idx,
      parameter,
      defaultExpandHelp: false,
      validationState
    }
  );
};
export default LookupTableParameterForm;
